export interface IMovelaria {
    razaoSocial: string;
    cnpj: string;
    inscricaoMunicipal?: string;
    inscricaoEstadual?: string;
    endereco: string;
    telefone: string;
    celular: string;
    email: string;
    cidade: string;
    estado: string;
    cep: string;
}

export const mockMovelaria: IMovelaria = {
    razaoSocial: 'ILC Cavalcante Movelaria',
    cnpj: '37.438.442/0001-24',
    inscricaoMunicipal: '123456789',
    inscricaoEstadual: '987654321',
    endereco: 'Rua das Palmeiras, 100',
    telefone: '(92) 3232-2323',
    celular: '(92) 9292-8476',
    email: 'profelizangela72@gmail.com',
    cidade: 'Itapiranga',
    estado: 'AM',
    cep: '69120-000'
};
